import React, { useEffect } from "react";
import { DateTimePicker, DateTimePickerProps } from "@material-ui/pickers";
import { BookingRules } from "api/bookings";
import moment from "moment";

// prop types
interface StartDatePickerProps {
    bookingRules: BookingRules,
    duration: number,
    pickerProps?: Partial<DateTimePickerProps>,
    startDate: string,
    onChange: (startDate: string) => void,
}

// start date form element
const StartDatePicker = ({ bookingRules, duration, pickerProps, startDate, onChange }: StartDatePickerProps) => {
    // change start date according to rules
    const changeStartDate = (newDate: moment.Moment) => {
        // court open & close time
        const ignoreDST = newDate.clone().dayOfYear(1);
        const minutesSinceMidnight = ignoreDST.diff(ignoreDST.clone().startOf("day"), "minutes");
        if (minutesSinceMidnight < bookingRules.openTimeMins) {
            newDate.hour(bookingRules.openTimeMins / 60);
        } else if (minutesSinceMidnight > bookingRules.closeTimeMins) {
            newDate.hour((bookingRules.closeTimeMins - duration) / 60);
        }

        // align to booking atom
        const atom = bookingRules.bookingAtomMins;
        const roundedMinutes = (Math.round(newDate.minutes() / atom) * atom) % 60;
        newDate.set({ minutes: roundedMinutes, seconds: 0, milliseconds: 0 });

        onChange(newDate.toISOString());
    };

    // validate value on rule change
    useEffect(() => bookingRules && changeStartDate(moment(startDate)), [bookingRules]); // eslint-disable-line

    // render
    return (
        <DateTimePicker
            ampm={false}
            disablePast
            minutesStep={15}
            value={startDate}
            variant="static"
            onChange={(m) => changeStartDate(m!)}
            {...pickerProps}
        />
    );
};

export default StartDatePicker;
